// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
const LOGIN_REQUEST = 'LOGIN_REQUEST';
const LOGIN_RESPONSE = 'LOGIN_RESPONSE';
const LOGIN_FAILED = 'LOGIN_FAILED';

const LOGIN_REQUEST_SUCCESS = 'LOGIN_REQUEST_SUCCESS';
const LOGIN_REQUEST_FAILED = 'LOGIN_REQUEST_FAILED';

const LOGIN_FIELD_CHANGE = 'LOGIN_FIELD_CHANGE';
const LOGIN_ERRORS_CHANGE = 'LOGIN_ERRORS_CHANGE';

const RESET_COMMON_ERROR = 'RESET_COMMON_ERROR';

export {
  LOGIN_REQUEST,
  LOGIN_RESPONSE,
  LOGIN_FAILED,

  LOGIN_REQUEST_SUCCESS,
  LOGIN_REQUEST_FAILED,

  LOGIN_FIELD_CHANGE,
  LOGIN_ERRORS_CHANGE,

  RESET_COMMON_ERROR,
};
